import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IntegrationModel } from 'src/app/models/api';

@Component({
  selector: 'app-inactive-integration-dialog',
  templateUrl: './inactive-integration-dialog.component.html',
  styleUrls: ['./inactive-integration-dialog.component.scss'],
})
export class InactiveIntegrationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<InactiveIntegrationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public integrationData: IntegrationModel
  ) {}

  public onClose(): void {
    this.dialogRef.close();
  }
}
